/**
 * Compass accuracy level constants.
 *
 * @since 8.2.0
 */
export var CompassAccuracy;
(function (CompassAccuracy) {
    /** High accuracy - approximates to less than 5 degrees of error */
    CompassAccuracy[CompassAccuracy["HIGH"] = 3] = "HIGH";
    /** Medium accuracy - approximates to less than 10 degrees of error */
    CompassAccuracy[CompassAccuracy["MEDIUM"] = 2] = "MEDIUM";
    /** Low accuracy - approximates to less than 15 degrees of error */
    CompassAccuracy[CompassAccuracy["LOW"] = 1] = "LOW";
    /** Unreliable accuracy - approximates to more than 15 degrees of error */
    CompassAccuracy[CompassAccuracy["UNRELIABLE"] = 0] = "UNRELIABLE";
    /** Unknown accuracy value */
    CompassAccuracy[CompassAccuracy["UNKNOWN"] = -1] = "UNKNOWN";
})(CompassAccuracy || (CompassAccuracy = {}));
//# sourceMappingURL=definitions.js.map